import * as lokalise from "lokalise"

export const initializeLocalise = () => {
  lokalise.initializeLocalise({
    project: "portal",
  })
}
